import React, { Component } from "react";
import styled from "styled-components";

import { Title, Subtitle } from "../themes/Blocks";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
  a {
    text-decoration: none;
  }
`;

const CourseDescription = styled.div`
  display: flex;
  padding: 20px;
  align-items: center;
  img {
    width: 95px;
    height: 63px;
    padding-right: 20px;
  }
`;

const Description = styled.div``;

const Course = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 40px -10px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.05);
`;
const CourseImage = styled.div`
  width: 100%;
  height: 200px;
  background-image: url("/riff.jpg");
  background-position: center;
  background-size: cover;
`;

const Codecamps = ({}) => (
  <Wrapper>
    <Title color="text" size="nm" margin="xs" bold>
      Become a professional React developer
    </Title>
    <Subtitle color="text" size="nm" margin="md">
      Next one-week React bootcamp
    </Subtitle>
    <a href="https://www.codecamps.com/rlp">
      <Course>
        <CourseImage />
        <CourseDescription>
          <img src="riff-logo.png" alt="React in Flip Flops logo" />
          <Description>
            <Title size="md" color="purple" margin="xs">
              React Las Palmas
            </Title>
            <Subtitle size="sm" color="text" thin>
              11-16 November, Las Palmas, Spain
            </Subtitle>
          </Description>
        </CourseDescription>
      </Course>
    </a>
  </Wrapper>
);

export default Codecamps;



// WEBPACK FOOTER //
// ./src/book/Codecamps.js